// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"e0aabc8d2852366d8cf8","838":"cf9bc4177f51410cbc68"}[chunkId] + ".css";
};